// extracted by mini-css-extract-plugin
export default {"amount":"item-row--amount--442104"};